import { memo, useState } from "react";
import "./tabmenubasic.css";
import Skeleton from "../skeleton/Skeleton";

export interface TabmenuBasicItem {
  title: string;
}

type TabmenuBasicProps = {
  items: TabmenuBasicItem[];
  isLoading: boolean;
  onTabSelected: (index: number) => void;
  isDisabled: boolean;
};

const TabmenuBasic: React.FC<TabmenuBasicProps> = ({ items, onTabSelected, isDisabled, isLoading }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  return (
    <div className="tab-menu">
      {items.map((item, index) => {
        return (
          <button
            disabled={isDisabled}
            key={index}
            className={selectedTabIndex === index ? "tab-menu-item selected" : "tab-menu-item"}
            onClick={() => {
              console.log("Onclicked tab index : ", index);
              setSelectedTabIndex(index);
              onTabSelected(index);
            }}
          >
            <div className="overlay"></div>
            <div className="title-small title">{item.title}</div>
            {/* &nbsp; <div className={getValueClassName(item.type)}>{isLoading ? <Skeleton /> : <Skeleton />}</div> */}
            <div className="selection-indicator"></div>
          </button>
        );
      })}
    </div>
  );
};

export default memo(TabmenuBasic);
